import { QueryClientScope } from "../types";
import { getAvailableLicenses } from "./getAvailablelicenses";
import { GetAvailableLicensesResponse } from "./types";
import { useQuery } from "@tanstack/react-query";

export const useAvailableLicenses = () => {
  return useQuery<GetAvailableLicensesResponse, Error>({
    queryKey: [QueryClientScope.License],
    queryFn: () => getAvailableLicenses(),
    staleTime: 60 * 60 * 1000,
  });
};
